import './styles.scss';

export const LoadingMessage = () => {
  return (
    <>
      <div className='loading'>
        <div className='load_wrapp'>
          <div className='loader'>
            <div className='line'></div>
            <div className='line'></div>
            <div className='line'></div>
          </div>
        </div>
      </div>
    </>
  );
};
